module.exports = __webpack_public_path__ + "static/img/quiz_center_title.c086b5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/quiz_center/quiz_center_title.png
// module id = SF7Z
// module chunks = 1